<template>
  <div>
    <div class="headline d-flex flex-row align-items-center justify-content-between w-100 border-bottom pb-3">
      <h2 class="card-title font-weight-bolder">{{ $t('administrator.details.profile.title') }}</h2>
      <div>
        <button @click="createSecurityListModal()" class="btn btn-primary mr-1">
          {{ $t('administrator.details.btn.security-check') }}
        </button>
        <button @click="resetGroupAndRoles" class="btn btn-danger mr-1">{{
            $t('administrator.details.btn.reset')
          }}
        </button>
        <button @click="saveGroupsAndRoles" class="btn btn-success">{{ $t('administrator.details.btn.save') }}</button>
      </div>
    </div>
    <AdministratorSecurityGroupSetter ref="group-setter"></AdministratorSecurityGroupSetter>
    <AdministratorSecurityRoleSetter ref="role-setter"></AdministratorSecurityRoleSetter>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import AdministratorSecurityGroupSetter from "./AdministratorSecurityGroupSetter";
import AdministratorSecurityRoleSetter from "./AdministratorSecurityRoleSetter";
import EntryAdministratorSecurityListModal from "../EntryAdministratorSecurityListModal";
import alertify from "alertifyjs";

export default {
  components: {
    AdministratorSecurityGroupSetter,
    AdministratorSecurityRoleSetter
  },
  computed: mapState({
    administratorSelectedRoles: state => state.administrator.selectedRoles,
    administratorSelectedGroups: state => state.administrator.selectedGroups,
    administratorData: state => state.administrator.administratorDetails
  }),
  methods: {
    saveGroupsAndRoles() {
      Promise.all([this.saveAdministratorRoles(), this.saveAdministratorGroups()]).then(() => {
        alertify.success('Success');
        this.$store.dispatch('administrator/getAdministratorDetails', this.administratorData.id.uuid);
      })
      .catch(error => {
        alertify.error(error.response.data.title);
      });
    },
    saveAdministratorRoles() {
      return new Promise(resolve => {
        const roles = [];
        this.administratorSelectedRoles.forEach(role => {
          roles.push(role.role);
        });

        const payload = {
          roles: roles
        }

        this.$store.dispatch('administrator/setAdministratorRole', payload).then(() => {
          resolve();
        })

      })
      .catch(error => {
        alertify.error(error.response.data.label);
      });
    },
    saveAdministratorGroups() {
      return new Promise(resolve => {
        const groups = [];

        this.administratorSelectedGroups.forEach(group => {
          const integerId = Number(group.id);

          groups.push(integerId);
        });

        const payload = {
          groups: groups
        }

        this.$store.dispatch('administrator/setAdministratorGroup', payload).then(() => {
          resolve();
        })
        .catch(error => {
          alertify.error(error.response.data.label);
        });
      });
    },
    resetGroupAndRoles() {
      this.$refs['role-setter'].setRoles();
      this.$refs['group-setter'].setGroups();
    },
    createSecurityListModal() {
      const
          ModalConstructor = Vue.extend(EntryAdministratorSecurityListModal),
          modal = new ModalConstructor({parent: this});

      modal.name = 'entry-administrator-security-list-modal';
      modal.title = 'Create entry';

      modal.$mount();
    },
  }
}
</script>
